import Backbone from "backbone";
import ColumnModel from "./ColumnModel";


export default Backbone.Collection.extend("Columns", {
    model: ColumnModel,

    /**
         * Получаем модель столбца, по ключу
         * @param  {String} key Ключ столбца
         * @memberof Columns.prototype
         */
    getByKey(key) {
        return this._byId[ key ];
    },

    has(key) {
        return key in this._byId;
    }
});
